import React, { useEffect, useState } from 'react'
import { NavLink } from 'react-router-dom';
import ArrowDown from '../../../assets/icons/ArrowDown';

function SubNavLink({options=[], data, i}) {
    const [subNav2Visible, setSubNav2Visible] = useState(true);

    const [color, setColor] = useState(true);
    const [navId, setNavId] = useState(true);

    const onCloseNav = () => {
        const btn = document.querySelector("#navBtn");
        if(btn){
            btn.checked = false;
            changeSub1Visible()
        }
    }

    const setBySize = () => {
        if(window.innerWidth <= 1100){
            setSubNav2Visible(false);
            setColor(false)
        }else{
            setSubNav2Visible(true);
            setColor(true)
        }
    }
    useEffect(()=>{
        window.addEventListener("resize", ()=>{
            setBySize();
        })
        setBySize()
    },[]);
    const changeSub1Visible = (data) =>{
        if(window.innerWidth <= 1100){
            setSubNav2Visible(!subNav2Visible);
            setNavId(data?.title)
        }
    }
  return (
    <li className={`${i!== options?.length - 1?"border-b":""} group relative sub-nav-list max-[1100px]:w-full`}>
    <div className='flex items-center justify-between px-[10px] w-full b'>
       {
            data?.options?.length !==0?
            <NavLink  onClick={data?.options?.length !== 0? ()=>changeSub1Visible(data):()=>onCloseNav()} className='text-[15px] text-[#222] font-[600] group-hover:text-[--red] max-[1100px]:group-hover:text-white max-[1100px]:text-white' to={data?.path}>{data?.title}</NavLink>:
            <NavLink  onClick={data?.options?.length !== 0? ()=>changeSub1Visible(data):()=>onCloseNav()} className='text-[15px] text-[#222] font-[600] group-hover:text-[--red]  max-[1100px]:group-hover:text-white max-[1100px]:text-white' to={data?.path}>{data?.title}</NavLink>
       }
        {
            data?.options?.length !== 0?
            <span className='w-[24px] h-[24px] rotate-[-90deg] link-icon '>
                <ArrowDown color={color?"var(--red)":"white"} width={'24px'} height={'24px'}/>
            </span>:null
        }
    </div>
    {
        data?.options?.length !==0 && subNav2Visible?
        <ul className='sub_sub_nav absolute right-[-200px] top-[-10px] shadow-xl bg-white shadow p-[10px] hidden flex-col gap-[7px] w-[200px] max-[1100px]:flex max-[1100px]:relative max-[1100px]:left-0 max-[1100px]:top-0 max-[1100px]:bg-white/20 max-[1100px]:shadow-none max-[1100px]:p-[10px] max-[1100px]:m-[10px] max-[1100px]:rounded-[5px]'>
           {
                data?.options?.map((item, j) => {
                    return(
                        <li key={j} className={`${j!== data?.options?.length - 1?"border-b max-[1100px]:border-b-[--red]":""} group/child`}>
                            <NavLink onClick={()=>onCloseNav()} className='text-[14px] text-[#222] font-[600] group-hover/child:text-[--red]' to={item?.path}>{item?.title}</NavLink>
                        </li>
                    )
                })
            }
           
        </ul>:null
    }
</li>
  )
}

export default SubNavLink
